import { highlightSegments } from '@/lib/utils';

/**
 * Renders `text` with every case-insensitive occurrence of `query` wrapped in
 * <mark>. Returns the text untouched when there is nothing to highlight.
 */
const HighlightedText = ({ text, query }) => {
  const segments = highlightSegments(text, query);

  if (segments.length === 1 && !segments[0].match) return <>{text}</>;

  return (
    <>
      {segments.map((segment, i) =>
        segment.match ? (
          <mark key={i} className="bg-yellow-200 text-inherit rounded-sm">
            {segment.text}
          </mark>
        ) : (
          <span key={i}>{segment.text}</span>
        )
      )}
    </>
  );
};

export default HighlightedText;
